(function () {

    'use strict';

    angular
        .module('AutoPrequal')
        .directive('googlePlace', ['$timeout', 'GoogleInitializer', function ($timeout, GoogleInitializer) {
            var componentForm = {
                street_number: 'long_name',
                route: 'long_name',
                locality: 'long_name',
                administrative_area_level_1: 'short_name',
                country: 'long_name',
                postal_code: 'short_name'
            };
            var mapping = {
                street_number: 'number',
                route: 'street',
                locality: 'city',
                administrative_area_level_1: 'province',
                country: 'country',
                postal_code: 'postal'
            };
            return {
                require: 'ngModel',
                scope: {
                    ngModel: '=',
                    details: '=?'
                },
                link: function (scope, element, attrs, model) {
                    var timeout = $timeout(function() {
                        //if google library takes longer than 500ms to load, show loader
                        scope.$root.forcedLoader = true;
                    }, 500);
                    //load google autocomplete
                    GoogleInitializer.getReadyPromise().then(function () {
                        $timeout.cancel(timeout);
                        scope.$root.forcedLoader = false;
                        var options = {
                            types: attrs.googlePlace !== "" ? attrs.googlePlace.split(',') : [],
                            componentRestrictions: { country: "ca" }
                        };
                        scope.addressApplied = true;

                        scope.gPlace = new google.maps.places.Autocomplete(element[0], options);

                        $timeout(function () {
                            $('.pac-container').attr('aria-live', 'assertive')
                        }, 1000);

                        $('.pac-item').attr('role', 'option')


                        element.bind('keyup', function (event) {
                            //resetting fields when user starts typing again (exclude enter, tab, shift)
							if (event.keyCode != 13 && event.keyCode != 9 && event.keyCode != 16) {
                                if (scope.addressApplied == true) {
                                    if (scope.$parent.addressType == "residential") {
                                        scope.$parent.data.apStreetNum = "";
                                        scope.$parent.data.apStreetName = "";
                                        scope.$parent.apStreetNameFull = "";
                                        scope.$parent.data.apCity = "";
                                        scope.$parent.data.apProvince = "";
                                        scope.$parent.data.apPostalCode = "";
                                    }
                                    scope.addressApplied = false;
                                }
                            }
                        });

                        google.maps.event.addListener(scope.gPlace, 'place_changed', function () {
                            var place = scope.gPlace.getPlace();
                            var details = place.geometry && place.geometry.location ? {
                                latitude: place.geometry.location.lat(),
                                longitude: place.geometry.location.lng()
                            } : {};

                            for (var i = 0; i < place.address_components.length; i++) {
                                var addressType = place.address_components[i].types[0];
                                if (componentForm[addressType]) {
                                    var val = place.address_components[i][componentForm[addressType]];
                                    details[mapping[addressType]] = val;
                                }
                            }

                            details.formatted = place.formatted_address;
                            details.placeId = place.place_id;

                            scope.$apply(function () {
                                if (scope.$parent.addressType === "residential") {
                                    scope.$parent.data.apStreetNum = details["number"];
                                    scope.$parent.data.apStreetName = details["street"] ? details["street"].substring(0, 23) : "";
                                    scope.$parent.apStreetNameFull = details["street"];
                                    scope.$parent.data.apCity = details["city"];
                                    scope.$parent.data.apProvince = details["province"];
                                    scope.$parent.data.apPostalCode = details["postal"] ? details["postal"].replace(/\s/g, "").toUpperCase() : "";
                                }

                                $timeout(function () {
                                    scope.$parent.checkProvince();
                                });

                                model.$setViewValue(element.val());

                                scope.addressApplied = true;
                            });
                        });

                        scope.$watch(function () { return $('.pac-container').html(); }, function (newVal, oldVal) {
                            $('.pac-item').attr('role', 'option')
                        });
                    })
                }
            };
        }]);
})();